export const bytesToMegabytes = (bytes: number) => bytes / (1024 * 1024);
